import { responsive, ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const stepper: ThemeUICSSObject = {
  alignItems: 'center',
  width: '100%',

  ol: (theme) => {
    return {
      display: 'flex',
      width: '100%',
      listStyle: 'none',
      m: '0',
      p: '0',

      li: {
        flex: '1',
        position: 'relative',
        display: 'list-item',
        listStyle: 'none',
        pt: '3',

        '&.current': {
          span: {
            fontWeight: 'bold',
          },
          '.stepperBar': {
            background: 'palette.primary.main',
          },
        },

        '&.completed': {
          '.stepperBar': {
            background: theme.palette.darkenColor('grey', 10),
            // background: 'palette.primary.main',
          },
        },

        '&.pending': {
          '.stepperBar': {
            backgroundColor: theme.palette.lightenColor('grey', 35),
          },
        },

        span: {
          display: responsive({ 0: 'none', 1: 'inline-block' }),
          textAlign: 'left',
          m: '0',
        },

        '&:first-of-type': {
          div: {
            width: '100%',
            height: '15px',
            clipPath: 'polygon(0% 0px, 100% 0px, 95% 100%, 0% 100%)',
            borderBottomLeftRadius: '7px',
            borderTopLeftRadius: '7px',
          },
        },
        '&:not(:first-of-type):not(:last-of-type)': {
          div: {
            width: '100%',
            height: '15px',
            clipPath: 'polygon(5% 0, 100% 0, 95% 100%, 0% 100%)',
          },
        },
        '&:last-of-type': {
          div: {
            width: '100%',
            height: '15px',
            clipPath: 'polygon(5% 0, 100% 0, 100% 100%, 0% 100%)',
            borderBottomRightRadius: '7px',
            borderTopRightRadius: '7px',
          },
        },
        '&:nth-child(1):nth-last-child(2)': {
          marginRight: responsive({ 0: '0px', 5: '-10px' }),
        },
      },
    };
  },
};

export default stepper;
